import styled, { css } from "styled-components";

export const TooltipCloseButtonBox = styled.div<{invertColors?: boolean}>`

    position: absolute;
    right: 10px;
    top: 10px;

    width: 10px;
    height: 10px;
    
    cursor: pointer;
    
    background-image: url("${props => props.theme.assets.images.close_modal_dialog_png.toString()}");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;    

    &:hover {
        opacity: 0.5;
    }

    
    ${({invertColors}) => invertColors? css`filter: invert(100%);` : ''}
 `;